import * as swcHelpers from '@swc/helpers';

const wait = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms)
        );
    });
    return function wait(ms) {
        return _ref.apply(this, arguments);
    };
}();
// Find the given errorCode, when facing an internal server error, the errorcode can be found within the original error
const getGraphQLErrorCode = (error1, errorCode)=>{
    return error1.graphQLErrors.find((error)=>{
        var ref, ref1, ref2, ref3;
        return ((ref = error.extensions) === null || ref === void 0 ? void 0 : ref.code) === errorCode || ((ref2 = (ref1 = error.extensions) === null || ref1 === void 0 ? void 0 : ref1.exception.originalError) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.extensions) === null || ref3 === void 0 ? void 0 : ref3.code) === errorCode;
    });
};
/*
  * Formats key-value pairs of versions:
  * {
      core: 'v100.0.0',
      www-gb-visionexpress: 'v45.0.0',
      ...
    }
  * into a string: www-gb-visionexpress@v45.0.0/core@v100.0.0
*/ const formatClientVersionInfo = (versions)=>{
    return Object.entries(versions || {}).map((parts)=>parts.join('@')
    ) // parts = [name, version]
    .join('/');
};

export { formatClientVersionInfo, getGraphQLErrorCode, wait };
//# sourceMappingURL=utils.js.map
